<template>
  <div id="app">
    <Header routeValue="-3"></Header>
    <content class="content">
      <img class="header" src="https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/header.jpg">
      <span class="title">About us</span>
      <span>Oasisdream, a US brand founded in 2019, and owned by DIKE INTERNATIONAL CO., LIMITED,</span>
      <span>is a leading name in the art sales industry. With a wide range</span>
      <span>of products including mugs, blankets, carpets, clothing, and automotive accessories,</span>
      <span>Oasisdream seamlessly integrates original designs into everyday life. The brand encompasses a diverse array of</span>
      <span>design styles, including cartoons, religious imagery, photography,</span>
      <span>animals, and landscapes. Through their commitment to promoting art</span>
      <span>and self-expression, Oasisdream has created a vibrant community of artists and art enthusiasts, inspiring</span>
      <span>creativity and celebrating the transformative power of art.</span>

      <span class="artistic">Your artistic voice. Express, create, inspire.</span>
      <div class="loop_box">
        <div class="loop">
          <swiper ref="mySwiper" :options="swiperOption" class="loop_c">
            <swiper-slide v-for="(item,index) in imgList" :key="index">
              <img :src="item" alt=""/>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>

      <div class="brief_box">
        <div class="company_view">
          <img style="width: 77px;height: 71px" src="../assets/company.png">
          <div class="company">
            <span>COMPANY</span>
            <span>DIKE INTERNATIONAL CO., LIMITED</span>
          </div>
        </div>
        <div class="company_view" style="margin-left: 56px">
          <img style="width: 59px;height: 72px" src="../assets/address.png">
          <div class="company">
            <span>ADDRESS</span>
            <span>room 1002 10/f easey commercial building</span>
            <span style="margin-top: -10px">253-261 hennesy road wanchai HK</span>
          </div>
        </div>
        <div class="company_view" style="margin-left: 95px">
          <img style="width: 73px;height: 63px" src="../assets/mail.png">
          <div class="company">
            <span>E-MAIL</span>
            <span>Support@oasisdream.shop</span>
          </div>
        </div>
      </div>
    </content>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
  name: 'AboutUs',
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide
  },
  data () {
    return {
      title: '',
      swiperOption: {
        loop: true,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        slidesPerView: 5,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      imgList: [
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/01.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/02.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/03.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/04.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/05.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/06.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/07.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/08.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/09.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/10.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/11.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/12.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/13.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/14.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/15.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/16.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/17.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/18.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/19.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/20.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/21.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/22.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/23.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/24.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/25.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/26.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/27.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/28.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/28.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/30.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/31.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/32.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/33.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/34.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/35.jpg',
        'https://dike-version.oss-cn-hongkong.aliyuncs.com/aboutus/36.jpg',
      ],
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
  },
  mounted () {
    window.scrollTo(0, 0)
    this.title = window.location.href
  },
  created () {
  },
  methods: {},
}
</script>
<style scoped lang="less">

.content {
  margin: 30px 100px 130px 100px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;

  .header {
    border-radius: 15px;
    width: 1714px;
    height: 472px;
  }

  .title {
    font-weight: 800;
    font-size: 50px;
    color: #4C8EFF;
    margin-top: 64px;
    margin-bottom: 40px;
  }

  span {
    font-weight: 500;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 40px;
  }

  .artistic {
    font-weight: 800;
    font-size: 35px;
    color: #4C8EFF;
    margin-top: 75px;
    margin-bottom: 53px;
  }

  .loop_box {
    width: 1714px;
    display: flex;
    justify-content: center;
    height: 372px;


    .loop {
      width: 1714px;
      height: 372px;

      .swiper-container {
        width: 100%;
        height: 100%;
      }

      .swiper-slide {
        text-align: center;
        font-size: 18px;
        -webkit-transition: transform 1.0s;
        -moz-transition: transform 1.0s;
        -ms-transition: transform 1.0s;
        -o-transition: transform 1.0s;
        -webkit-transform: scale(0.73);
        transform: scale(0.73);
      }

      .swiper-slide-active,
      .swiper-slide-duplicate-active {
        margin-right: 6px;
        margin-left: -11px;
        -webkit-transform: scale(1);
        transform: scale(1);
      }

      .swiper-slide img {
        width: 327px;
        height: 372px;
        border-radius: 10px;
        margin-left: 23%;
        border: 1px solid #4C8EFF;
      }

      .swiper-button-prev:after, .swiper-button-next:after {
        font-size: 35px;
      }

      .swiper-button-prev,
      .swiper-container-rtl .swiper-button-next {
        left: 0;
        right: auto;
      }

      .swiper-button-prev:after,
      .swiper-container-rtl .swiper-button-next:after {
        content: 'prev';
      }

      .swiper-button-next,
      .swiper-container-rtl .swiper-button-prev {
        right: 0;
        left: auto;
      }

      .swiper-slide-prev {
        margin-left: -58px;
        transform: scale(0.88);
      }

      .swiper-slide-next {
        margin-right: -34px;
        transform: scale(0.88);
      }
    }
  }

  .brief_box {
    width: 1372px;
    display: flex;
    margin-top: 128px;


    .company_view {
      display: flex;
      align-items: center;

      .company {
        display: flex;
        flex-direction: column;
        margin-left: 14px;

        span:nth-child(1) {
          font-weight: bold;
          font-size: 28px;
          margin-bottom: -5px;
          color: #4C8EFF;
        }

        span:nth-child(2) {
          font-weight: 400;
          font-size: 20px;
          color: #FFFFFF;
        }
      }

    }

  }

}
</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue